// extracted by mini-css-extract-plugin
export var gif = "_ii-0";